// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 56px;
  background-color: #f5f5f5;
}

.heading h1 {
  font-size: 32px;
  font-weight: 700;
}

.heading ul {
  margin: 24px 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px 32px;
}

.heading li {
  list-style: none;
  font-size: 12px;
}

.heading li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: rgb(37, 85, 174);
  font-weight: 700;
}

.heading li a svg {
  font-size: 24pt;
}

.heading li a span {
  font-size: 11px;
  line-height: 1.3;
}

.heading li a:hover {
  color: rgb(176, 12, 127);
}

@media (max-width: 1050px) {
  .heading {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/heading/heading.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".heading {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 56px;\n  background-color: #f5f5f5;\n}\n\n.heading h1 {\n  font-size: 32px;\n  font-weight: 700;\n}\n\n.heading ul {\n  margin: 24px 0 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 24px 32px;\n}\n\n.heading li {\n  list-style: none;\n  font-size: 12px;\n}\n\n.heading li a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  text-decoration: none;\n  color: rgb(37, 85, 174);\n  font-weight: 700;\n}\n\n.heading li a svg {\n  font-size: 24pt;\n}\n\n.heading li a span {\n  font-size: 11px;\n  line-height: 1.3;\n}\n\n.heading li a:hover {\n  color: rgb(176, 12, 127);\n}\n\n@media (max-width: 1050px) {\n  .heading {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
